import { InterventionReportAttendee, PrestazioneData, ServiceRating } from 'utils/interfaces';
import { EMPTY_PRESTAZIONE } from './prestazioneConfig';

export interface ReportFormOperator {
  employeeId: number;
  firstName: string;
  lastName: string;
  present: boolean;
}

export interface ReportFormVehicle {
  id: number;
  name: string;
  plate: string | null;
  selected: boolean;
}

export interface ReportAttachment {
  // number = already persisted on the server (from a previous save); string = added this session,
  // not yet uploaded — this is what tells the UI/upload logic which ones to send as new files.
  id: number | string;
  fileName: string;
  // blob: URL — for a brand-new attachment it comes straight from the picked File; for an existing
  // one it's fetched (authenticated) and converted to a blob URL by the caller. Either way it's a
  // ready-to-use <img>/jsPDF source with no auth header needed.
  previewUrl: string;
  file?: File;
}

export interface ReportFormState {
  // ISO "YYYY-MM-DD" — only actually editable via InterventionReportForm's canEditReportDate (admin
  // report-detail edit); everywhere else it's carried through unchanged.
  reportDate: string;
  clientName: string;
  clientCity: string;
  clientAddress: string;
  clientTaxCode: string;
  clientVatNumber: string;
  clientPhone: string;
  clientEmail: string;
  prestazione: PrestazioneData;
  notes: string;
  startTime: string;
  endTime: string;
  operators: ReportFormOperator[];
  attendees: InterventionReportAttendee[];
  vehicles: ReportFormVehicle[];
  customerSignerName: string;
  customerSignatureDataUrl: string | null;
  serviceRating: ServiceRating | null;
  attachments: ReportAttachment[];
}

export const EMPTY_REPORT_FORM_STATE: ReportFormState = {
  reportDate: '',
  clientName: '',
  clientCity: '',
  clientAddress: '',
  clientTaxCode: '',
  clientVatNumber: '',
  clientPhone: '',
  clientEmail: '',
  prestazione: EMPTY_PRESTAZIONE,
  notes: '',
  startTime: '',
  endTime: '',
  operators: [],
  attendees: [],
  vehicles: [],
  customerSignerName: '',
  customerSignatureDataUrl: null,
  serviceRating: null,
  attachments: [],
};

// EGR's own internal placeholder address, used when a customer has no real email on file — it must
// never be shown back to anyone reading the report (web view or PDF), only ever used internally.
const HIDDEN_CLIENT_EMAIL = 'info@ecogrouprizzi.it';

export const displayableClientEmail = (email: string | null | undefined): string =>
  email && email.trim().toLowerCase() === HIDDEN_CLIENT_EMAIL ? '' : (email || '');

// reportDate comes from the backend as a LocalDate ("YYYY-MM-DD"). The report views/PDF need it
// as "GG-MM-YYYY" instead — reordering the plain string avoids any Date/timezone parsing at all.
export const displayReportDate = (reportDate: string): string => reportDate.split('-').reverse().join('-');

export const SERVICE_RATING_OPTIONS: { value: ServiceRating; label: string }[] = [
  { value: 'INSUFFICIENTE', label: 'Insufficiente' },
  { value: 'SUFFICIENTE', label: 'Sufficiente' },
  { value: 'DISCRETO', label: 'Discreto' },
  { value: 'BUONO', label: 'Buono' },
  { value: 'OTTIMO', label: 'Ottimo' },
];
